export default "__VITE_ASSET__DR6u9m_0__"